import React, { useState } from 'react';

const TTL_OPTIONS = [
    { label: 'Auto', value: 1 },
    { label: '5 min', value: 300 },
    { label: '1 hora', value: 3600 },
    { label: '1 dia', value: 86400 },
];

const BulkActions = ({ selectedCount, onBulkDelete, onBulkEditTTL, onBulkToggleProxy, onDeselectAll }) => {
    const [showTTLDropdown, setShowTTLDropdown] = useState(false);

    if (!selectedCount || selectedCount === 0) return null;

    return (
        <div className="bulk-actions-bar" style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: '#1f2937',
            color: '#fff',
            padding: '12px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            zIndex: 999,
            boxShadow: '0 -2px 10px rgba(0,0,0,0.3)',
        }}>
            <span style={{ fontSize: '14px', fontWeight: 500 }}>
                {selectedCount} registros selecionados
            </span>
            <div style={{ display: 'flex', gap: '8px', alignItems: 'center', position: 'relative' }}>
                <div style={{ position: 'relative' }}>
                    <button
                        onClick={() => setShowTTLDropdown(!showTTLDropdown)}
                        style={{
                            padding: '6px 14px',
                            fontSize: '13px',
                            backgroundColor: '#374151',
                            color: '#fff',
                            border: '1px solid #4b5563',
                            borderRadius: '6px',
                            cursor: 'pointer',
                        }}
                    >
                        Alterar TTL
                    </button>
                    {showTTLDropdown && (
                        <div style={{
                            position: 'absolute',
                            bottom: '100%',
                            left: 0,
                            marginBottom: '4px',
                            backgroundColor: '#374151',
                            border: '1px solid #4b5563',
                            borderRadius: '6px',
                            overflow: 'hidden',
                            minWidth: '120px',
                        }}>
                            {TTL_OPTIONS.map(opt => (
                                <div
                                    key={opt.value}
                                    onClick={() => {
                                        onBulkEditTTL(opt.value);
                                        setShowTTLDropdown(false);
                                    }}
                                    style={{
                                        padding: '8px 14px',
                                        fontSize: '13px',
                                        cursor: 'pointer',
                                        borderBottom: '1px solid #4b5563',
                                    }}
                                    onMouseEnter={e => e.currentTarget.style.backgroundColor = '#4b5563'}
                                    onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                    {opt.label} ({opt.value})
                                </div>
                            ))}
                        </div>
                    )}
                </div>
                <button
                    onClick={onBulkToggleProxy}
                    style={{
                        padding: '6px 14px',
                        fontSize: '13px',
                        backgroundColor: '#374151',
                        color: '#fff',
                        border: '1px solid #4b5563',
                        borderRadius: '6px',
                        cursor: 'pointer',
                    }}
                >
                    Toggle Proxy
                </button>
                <button
                    onClick={onBulkDelete}
                    style={{
                        padding: '6px 14px',
                        fontSize: '13px',
                        backgroundColor: '#ef4444',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                    }}
                >
                    Deletar
                </button>
                <button
                    onClick={onDeselectAll}
                    style={{
                        padding: '6px 14px',
                        fontSize: '13px',
                        backgroundColor: 'transparent',
                        color: '#9ca3af',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        textDecoration: 'underline',
                    }}
                >
                    Desmarcar
                </button>
            </div>
        </div>
    );
};

export default BulkActions;
